import React from 'react';
import './About.css';
import { FaTrophy, FaIndustry, FaChartLine, FaRegThumbsUp, FaUsers, FaLightbulb } from 'react-icons/fa';

function About() {
  const aboutInfo = `
    The A.A. Smart Jet Technology was established 5+ years ago and is recognized across all commercial and public sectors 
    as one of the largest suppliers of printer machines and Spare parts. A.A. Smart Jet Technology focuses on 
    market-leading service, forward-thinking product offerings, and putting our customer's current and future needs at the 
    forefront of any business development. All types of CIJ & TIJ printers, Lasers, services, and consumables like Ink, Solvent, Makeup, Washsolutions.
  `;

  return (
    <div className='about-page-container'>
      <div className='about-page-content'>
        <h1 className='about-page-title'>About Us</h1>
        <p className='about-page-text'>{aboutInfo}</p>
      </div>

      <div className='milestones-section'>
        <h2>Our Milestones</h2>
        <ul className='milestones-list'>
          <li><FaTrophy className="icon"/> Established over 5 years ago</li>
          <li><FaIndustry className="icon"/> Leading supplier in the industry</li>
          <li><FaChartLine className="icon"/> Expanded product offerings to meet future needs</li>
        </ul>
      </div>

      <div className='values-section'>
        <h2>Our Values</h2>
        <ul className='values-list'>
          <li><FaRegThumbsUp className="icon"/> Commitment to Quality</li>
          <li><FaUsers className="icon"/> Customer-Centric Approach</li>
          <li><FaLightbulb className="icon"/> Innovation and Growth</li>
        </ul>
      </div>
    </div>
  );
}

export default About;
